export const getTooltipTemplate = tooltipDirection => `
    <span class="tooltip-wrapper">
        <span class="tooltip__icon_container">
            <i class="axa-icons axa-icons-info-outline tooltip__icon priips__tooltip__circle"></i>
            <i class="axa-icons axa-icons-info tooltip__icon__hover priips__tooltip__circle"></i>
        </span>
        <div class="tooltip tooltip__content ${tooltipDirection}"></div>
        <span class="tooltip__arrow"></span>
    </span>
`;

export const getTooltip = (tooltipMessage, tooltipDirection) => `
    <span data-module="tooltip"
        data-module-tooltip--tooltip-message="${tooltipMessage}"
        data-module-tooltip--tooltip-direction="${tooltipDirection}">
    </span>
`;
